import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

export const CartValidation = () => {
  return (
    <Alert>
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        Important : Votre signature numérique est requise pour valider cette vente. 
        Cette signature est connue uniquement de vous et de votre responsable. 
        Une vente sans signature valide sera considérée comme non autorisée.
        {"\n"}
        Le mode de paiement est obligatoire pour toute vente standard.
      </AlertDescription>
    </Alert>
  );
};